// @flow

import type { Pin } from 'app/common/react/components/PinRep/types';
import type { Video } from 'app/packages/pinterest-flow-types/video';
import type { CloseupPin, GridPin } from 'app/packages/pinterest-flow-types/pin';

/**
 * A utility function that takes a Pin type and returns either the Video object
 * or null if it turns out nothing exists.
 *
 * @export
 * @param {Pin} pin
 * @returns {?Video}
 */
export default function getVideoFromPin(pin: Pin | GridPin | CloseupPin): ?Video {
  const videoList =
    pin.videos && pin.videos.video_list && Object.keys(pin.videos.video_list).length > 0
      ? pin.videos.video_list
      : null;
  return videoList ? videoList.V_HLSV3_MOBILE || videoList.V_HLSV4 || videoList.V_720P : null;
}
